var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchableTable',{attrs:{"panel-header":'Nutzer',"panel-route":'AddUser',"show-search-bar":true,"table-data":_vm.staffUsers,"table-meta-data":_vm.tableMetaData,"query-string":'setUserSearchQuery',"initial-search-query":_vm.userSearchQuery,"row-click":_vm.triggerView,"default-sort":['attributes.email', 'asc']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }